$(document).ready(function() {
	if (!$.fn.select2) {
		return;
	}

	$('.frm-select2').each(function() {
		const $select = $(this);

		if ($select.data('select2')) {
			return;
		}

		$select.select2({
			width: '100%',
			minimumResultsForSearch: 20,
			placeholder: $select.data('placeholder') || undefined
		});

		// Fix categories filter
		$select.on('select2:select select2:unselect', function () {
			this.dispatchEvent(new Event('change', { bubbles: true }));
		});

		const mode = $select.data('frm-select2');
		const $container = $select.next('.select2-container');

		if (mode) {
			$container.addClass(`frm-select2-container--${mode}`);
		}

		if (mode === 'multiple') {
			const placeholder = $select.data('placeholder') || '';
			const syncEmptyState = () => {
				const hasValue = ($select.val() || []).length > 0;

				$container.toggleClass('frm-select2-container--empty', !hasValue);
			};

			$container
				.find('.select2-selection--multiple')
				.attr('data-placeholder', placeholder);

			syncEmptyState();
			$select.on('change', syncEmptyState);
		}
	});
});
